module.exports = __webpack_public_path__ + "img/fi-rr-zoom-in.a9cfd721.svg";